import styled from "styled-components"
import { colors } from "../../styles/colors"
import Fondo2 from "../../styles/Fondo2.png"

export const ContainerSkills = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(2, 1fr);
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    background: transparent;
    @media (max-width: 768px){
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr); 
        margin-top: 20px;
    }
`;

export const IdSkills = styled.h3`
    font-size: 50px;
    text-transform: uppercase;
    background: #61bdfb;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Russo One', sans-serif;
    
    @media (max-width: 768px){
        font-size: 25px;     
        color: #61bdfb;
        background-clip: none;
        -webkit-background-clip: none;
        -webkit-text-fill-color: #61bdfb;
        text-shadow: black 1px 2px 2px;
    }

    @media (max-width: 340px){
        font-size: 20px;
        color: #61bdfb;
        background-clip: none;
        -webkit-background-clip: none;
        -webkit-text-fill-color: #61bdfb;
        text-shadow: black 1px 2px 2px;
    }
`;

export const ImageSkills = styled.div`
    display: grid;
    align-items: center;
    justify-content: center;
    font-size: 2px;
    background: transparent;
    div{        
        text-align: center;
        max-width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 100px;
        background: transparent;
    }
    
    img {
        width: 130px;
        height: 130px;
        height: auto;
        background: transparent;
    }
    
    p{
        text-align: center;
        font-size: 8px;
        color: ${colors.TEXT_GREY_NEUTRAL};
        
    }
    
    @keyframes fadeInSkills {
        from {
            opacity: 0;
            transform: translateX(-100%);
        }
        
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    
    @media (max-width: 768px){
        div {
            padding: 80px;
            margin: 10px;
            width: 100%;
        }
        
        img{            
            width: 60px;
        }

        @media (max-width: 340px){
            div {
                padding: 50px;
            }
            
            img{
                width: 40px;
            }
        }
    }
`;

export const ImageBarras = styled.div`
    img {
        width: 50px;
        height: 50px;
    }
`

export const ContainerAll = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 100px 0;
    background-image: url(${Fondo2});
    opacity: 0;
    border-top: solid;
    border-bottom: solid;
    border-width: 5px;
    border-image: radial-gradient( #ffffff 20%, #181818 85%) 1;
    /* border-top: solid radial-gradient(#ffffff, #181818);
    border-bottom:#404040 solid; */
    
    @keyframes fondoSkills {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    
    
    @media (max-width: 768px){
        /* background: #181818; */
        padding: 70px 0;
        margin-top: 60px;
        text-align: center;
    }
`

export const BarraGral = styled.div`
    display: grid;
    width: 50%;
    background-color: transparent;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(2, 1fr);
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    background: transparent;

    @media (max-width: 768px){
        width: 30%;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr); 
    }
    `
export const BarraColor = styled.div`
    width: 100%;
    background-color: #61bdfb;
    margin: 10px 0;
    height: 20px;
    opacity: 0;

    
    @keyframes barraHTML {
        0%{width: 0; opacity: 0;}
        100%{width: 70%; opacity: 100;}
    }

    @keyframes barraCSS {
        0%{width: 0; opacity: 0;}
        100%{width: 90%; opacity: 100;}
    }

    @keyframes barraJS {
        0%{width: 0; opacity: 0;}
        100%{width: 60%; opacity: 100;}
    }

    @keyframes barraNodeJS {
        0%{width: 0; opacity: 0;}
        100%{width: 40%; opacity: 100;}
    }

    @keyframes barraReact {
        0%{width: 0; opacity: 0;}
        100%{width: 50%; opacity: 100;}
    }

    @keyframes barraGit {
        0%{width: 0; opacity: 0;}
        100%{width: 70%; opacity: 100;}
    }

    @keyframes barraSass {
        0%{width: 0; opacity: 0;}
        100%{width: 60%; opacity: 100;}
    }

`

export const BloqueUno = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 200px;
    height: 200px;    
    background: transparent;
    margin: 20px 10px;
    @media (max-width: 768px){
        width: 120px;
        height: 120px;
    }
  
`


export const Porcentaje = styled.div`
    font-family: 'Russo One', sans-serif;
    /* font-size: 5px; */
    background-color: transparent;
    color: white;
    opacity: 0;
    animation-name: porcentaje;
    animation-duration: 3s;
    animation-fill-mode: forwards;
    h1 {
        background-color: transparent;
    }

    @keyframes porcentaje {
        from {
            opacity:0;
        }
        to {
            opacity:100;
        }
    }
    @media (max-width: 768px){
        font-size: 20px;
    }
`
export const ProgressBar = styled.div`
    
    background: transparent;

  @media (max-width: 768px){
    width: 150px;
    height: 100%;
  }
`;

export const CircularProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: conic-gradient(
    #3498db 0%,
    #3498db ${(props) => props.progress}%,
    transparent ${(props) => props.progress}%,
    transparent 100%
  );
  transition: 3s;
  z-index: 1;
`;

export const CircleIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    background-image: url(${Fondo2});
    z-index: 50;
    height: 85%;
    width: 85%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    img {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 3em;
        background: transparent;
        /* height: 100%; */
        position: absolute;
        z-index: 1;
        width: 150px;
        height: 150px;
        border-radius: 10%;
    }
  @media (max-width: 768px){
    img {
    width: 90px;
    height: 90px;
    }
  }
`;